export function getRem(value?: number | string) {
  return typeof value === 'number' ? `${value / 10}rem` : value;
}
